import { Modal, Button } from "../../design";
import { translate } from "../../utils/translations";
import { useRouter } from "next/router";
import { safeStorage } from "../../utils/helpers";

function LogoutModal(props: any) {
    const router = useRouter();

    const logoutButtonAction = () => {
        safeStorage.removeItem("loopAccessToken");
        safeStorage.removeItem("loopRefreshToken");

        router.replace(`${process.env.NEXT_PUBLIC_PROXY_PATH}/get-subscription-link`);
    }

    return (
        <Modal title={translate('cp_logout_modal_title')} active={props.active} toggleActive={props.toggleActive}>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: translate('cp_logout_modal_body') }}></div>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex flex-row-reverse">
                    <Button className="m-2" onClick={logoutButtonAction}>{translate('cp_logout_modal_confirm_button')}</Button>
                    <Button variant="underline" className="m-2" onClick={props.toggleActive}>{translate('cp_logout_modal_cancel_button')}</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default LogoutModal;